
<div class="custom-control custom-checkbox" aria-role="checkbox">
  <input class="custom-control-input" type="checkbox" [checked]="displayValue" [disabled]="disabled || controlDisabled">
  <label class="custom-control-label">{{text}}</label>
</div>